import Turndown from "turndown";
import jQuery from "jquery";
import callDotNet from "../blazor/callDotNet.js";

const turndown = new Turndown({
    headingStyle: 'atx',
    hr: '---',
    bulletListMarker: '-',
    emDelimiter: '__',
    codeBlockStyle: 'fenced',
});
turndown.addRule('strikethrough', {
    filter: ['del', 's', 'strike'],
    replacement: function (content) {
        return '~~' + content + '~~'
    }
});
turndown.keep(['span']);

const blazorUpdate = (element) => {
    let markdown = turndown.turndown(element._quill.getSemanticHTML());
    markdown = markdown.replaceAll('\\-', '-');
    markdown = markdown
        .replace(/&nbsp;/gi, ' ')
        .replace(/\u00A0/g, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'");
    callDotNet(element, "OnBlur", markdown);

    console.log('#' + element.id + '.submitOnBlur: ' + element.dataset.submitOnBlur);
    if (element.dataset.submitOnBlur === 'true') {
        setTimeout(function () {
            console.log('#' + element.id + '.submit');
            const $submit = jQuery(element).closest('form').find('button[type=submit]');
            if ($submit.length >= 1) {
                $submit.click();
            }
            element.dataset.submitOnBlur = 'false';
        }, 100);
    }
};

export default blazorUpdate;
